import styled, { css } from 'styled-components'
import { CurrentProgressProps } from './interfaces'

export const Container = styled.div`
  margin-bottom: 44px;
  width: 100%;
  height: 8px;
  background-color: ${({ theme }) => theme.neutral.border.default};
  border-radius: 50px;

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    margin-bottom: ${({ theme }) => theme.spacing.km12};
    margin-top: ${({ theme }) => theme.spacing.km2};
  }
`

export const CurrentProgress = styled.div<CurrentProgressProps>`
  background-color: ${({ theme }) => theme.brand.background.default};
  height: 100%;
  position: relative;
  border-radius: 50px;

  ${({ $progress, $transitionTime }) =>
    css`
      width: ${$progress}%;
      transition: width ${$transitionTime}s ease;
    `};

  &::before {
    content: '';
    width: 16px;
    height: 16px;
    position: absolute;
    top: 50%;
    left: calc(100% - 10px);
    transform: translateY(-50%);
    background-color: ${({ theme }) => theme.brand.background.default};
    border-radius: ${({ theme }) => theme.border.radius.circle};
  }
`
